import React from 'react'
import { Announcement } from '../../models/Announcement'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { ClickAwayListener, Grow, Paper, Popper } from '@mui/material';
import AnnouncementPiece from './AnnouncementPiece';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { useTranslation } from 'react-i18next';
import useFetch from '../../hooks/useFetch';
import { closeAnnouncementsRoute } from '../../config/apiRoutes';

type Props = {
    announcements: Announcement[];
    handleRefresh: () => void;
}

const AnnouncementAlert = ({ announcements, handleRefresh }: Props) => {
    const { t } = useTranslation();
    const [isPopperOpen, setIsPopperOpen] = React.useState(false);
    const anchorRef = React.useRef<HTMLDivElement>(null);
    const caller = useFetch();

    const handleToggle = () => {
        setIsPopperOpen((prevOpen) => !prevOpen);
    };

    async function closeAnnouncements() {
        const response = await caller.call("POST", closeAnnouncementsRoute, {
            ids: announcements.map((announcement) => announcement.id)
        });
        if (response.ok) {
            handleRefresh();
        }
    }

    function onCloseClick(){
        closeAnnouncements();
        setIsPopperOpen(false);
    }

    if (announcements.length === 0) {
        return <></>
    }

    return (
        <>
            <div ref={anchorRef} className="absolute bottom-[10px] right-[10px] z-50">
                <div className="relative" onClick={handleToggle}>
                    <div
                        className="text-[14px] font-semibold shadow-md absolute top-[-5px] right-[-5px] rounded-full bg-strike text-white z-50 w-[22px] h-[22px] flex items-center justify-center ">
                        {announcements.length}
                    </div>
                    <div
                        className="rounded-full bg-primary p-2 flex items-center justify-center text-white shadow-lg cursor-pointer hover:scale-105 transition-transform duration-200">
                        <InfoOutlinedIcon style={{ fontSize: "38px", }} />
                    </div>
                </div>
            </div>
            <Popper
                open={isPopperOpen}
                anchorEl={anchorRef.current}
                role={undefined}
                placement="top-start"
                transition
                disablePortal
                style={{ zIndex: 1000, width: `300px` }}
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin:
                                placement === 'bottom-start' ? 'left top' : 'left bottom',
                            marginLeft: "10px",
                            marginRight: "10px",
                        }}
                    >
                        <Paper
                            style={{ overflowY: "auto", marginBottom: "3px" }}
                        >
                            <ClickAwayListener onClickAway={() => setIsPopperOpen(false)}>
                                <div>
                                    <div className="bg-primary flex p-[3px]" >
                                        <div className="grow text-white font-bold pl-1 text-[18px] pt-[3px]">
                                            {t("common.announcements")}
                                        </div>
                                        <button
                                            onClick={onCloseClick}
                                            className="text-white hover:bg-primary-dark rounded-full p-[3px] transition-all">
                                            <CloseOutlinedIcon />
                                        </button>
                                    </div>
                                    <div
                                        className="flex flex-col gap-[3px] bg-primary overflow-y-auto max-h-[300px]"
                                    >
                                        {announcements.map((announcement) => {
                                            return <AnnouncementPiece key={announcement.id} announcement={announcement} />
                                        })}
                                    </div>
                                </div>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </>
    )
}

export default AnnouncementAlert